module.exports = __webpack_public_path__ + "img/small-tiktok.2ccc550c.svg";